module.exports = __webpack_public_path__ + "cf4603b7ca74e6ef964edd30094f6cca.pdf";